'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { VariantProps } from 'class-variance-authority'
import { ComponentProps, ReactNode } from 'react'

import { cn } from '../../utils/cn'
import { BaseButton, useButtonContext } from './base-button'
import { ButtonIcon } from './button-icon'
import { buttonStyles } from './buttonStyles'
import { LayeredStack } from './layered-stack'
import { LoadingIcon } from './loading-icon'

type ButtonVariantProps = VariantProps<typeof buttonStyles>

export function Button({
  variant,
  size,
  className,
  type = 'button',
  isLoading,
  isLoadingOverride,
  ...props
}: ComponentProps<typeof BaseButton> &
  ButtonVariantProps & {
    /** @deprecated either use `isLoadingOverride` or use the default loading behavior of a submit button */
    isLoading?: boolean
  }) {
  return (
    <BaseButton
      className={cn(buttonStyles({ variant, size }), className)}
      type={type}
      isLoadingOverride={isLoadingOverride ?? isLoading}
      {...props}
    />
  )
}

/**
 * Renders a loading spinner whenever the Button's `isLoading` prop is true
 * Or when the button is a submit button and the form is loading
 * If any children are provided, they will be hidden while the spinner is visible
 *
 * @example
 * <form action={someAction}>
 *   <Button type="submit">
 *     <ButtonLoader>
 *       <ButtonIcon>
 *         <DiscIcon />
 *       </ButtonIcon>
 *     </ButtonLoader>
 *     Save
 *   </Button>
 * </form>
 *
 * @example
 * <Button isLoading>
 *   <ButtonLoader>
 *     <ButtonIcon>
 *       <DiscIcon />
 *     </ButtonIcon>
 *   </ButtonLoader>
 *   Save
 * </Button>
 *  */
export function ButtonLoader({ children }: { children?: ReactNode }) {
  const { isLoading } = useButtonContext()
  return (
    <LayeredStack>
      <span
        className={cn(
          'transition-opacity',
          isLoading ? 'opacity-0' : 'opacity-100',
        )}
      >
        {children}
      </span>
      <LoadingIcon
        aria-hidden
        className={cn(
          'size-4.5 transition-opacity',
          isLoading ? 'opacity-100' : 'opacity-0',
        )}
      />
    </LayeredStack>
  )
}

export { ButtonIcon }
